import { Box, Grid, Switch, Typography } from "@mui/material"
import { Dispatch, SetStateAction, useState } from "react"
import { useSubscription } from "../../../../Hooks/useSubscription"
import { SubscriptionTier } from "../../../../Types/Client"
import { ISubscription } from "../../../../Types/subcription"
import { useUser } from "../../../../Hooks/useUser"
import { SubscriptionCard } from "./SubscriptionCard"
import { africanCountries } from "../../../../Types/General"
import { KaziSwitch } from "../../../../Shared Components/Kazi/KaziSwitch"


interface EditPlanProps {
}
export const EditPlan = ({ }: EditPlanProps) => {
    /* ******************** Hooks ******************** */
    const { subscriptions } = useSubscription();
    const { userSubscription, user } = useUser();
    const [checked, setChecked] = useState(false);
    /* ******************** Variables ******************** */
    const isAfricanClient = africanCountries.some( c => c.Country === user?.country);
    /* ******************** Functions ******************** */
    const handleChecked = () => setChecked(!checked);
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Box
                display={'flex'}
                flexDirection={'row'}
                gap={2}
            >
                <Typography variant="lora-headline-small">Membership plans</Typography>
                <KaziSwitch leftLabel="Monthly" rightLabel="Annual" checked={checked} onChange={handleChecked}/>
            </Box>
            <Grid
                display={'flex'}
                flexDirection={'row'}
                gap={'32px'}
                marginTop={2}
            >
                {
                    subscriptions?.filter((s: ISubscription) => isAfricanClient ? s.tier != SubscriptionTier.Premium : s.tier != SubscriptionTier.PremiumAfrica).map((s) => (
                        <SubscriptionCard 
                            subscription={s}
                            currentPlan={userSubscription.tier == s.tier}
                            isMonthly={!checked}
                        />
                    ))
                }
            </Grid>
        </>
    )
}